<template>
    <tr :class="getTrClass(rowLevel, 1)">
        <td
            class="row-heading"
            v-html="getRowHeading(rowLevel.rowLevel.title.toString())"
        ></td>
        <td class="statistic-label hidden-heading-column"></td>
        <template v-for="model in models">
            <statistic-value
                :statistic="model"
                v-bind:key="100 + model.id"
            ></statistic-value>
            <statistic-ci
                v-if="reportModel.parms.showCi && model.statisticDefinition.ci"
                :statistic="model"
                v-bind:key="200 + model.id"
            ></statistic-ci>
            <statistic-se
                v-if="reportModel.parms.showSe && model.statisticDefinition.se"
                :statistic="model"
                v-bind:key="300 + model.id"
            ></statistic-se>
        </template>
    </tr>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import current from '@/scripts/current';
import statisticValue from '@/components/crossTabulation/report/statisticValue';
import statisticCi from '@/components/crossTabulation/report/statisticCi';
import statisticSe from '@/components/crossTabulation/report/statisticSe';
import CtReportCell from '@/bo/CtReportCell';

export default {
    props: ['reportModel', 'rowLevel', 'row'],
    computed: {
        selectionModel: function () {
            return current.selectionModel;
        }
    },
    data: function () {
        var vm = this;
        return {
            headingRow:
                Math.floor((vm.reportModel.usedStatistics.length + 1) / 2) - 1,
            models: vm.reportModel.usedStatistics.map(
                (s, i) =>
                    new CtReportCell({
                        id: i,
                        rowLevel: vm.rowLevel,
                        columnData: vm.rowLevel.apiStatistics[0],
                        statisticDefinition: s,
                        totalSourceRecords: vm.row.totalSourceRecords
                    })
            )
        };
    },
    components: {
        // <my-component> will only be available in parent's template
        'statistic-value': statisticValue,
        'statistic-ci': statisticCi,
        'statistic-se': statisticSe
    },
    methods: {
        makeSpacesNonBreaking: function (label) {
            return label.replace(/\s/g, '&nbsp;');
        },
        getRowHeading: function (label) {
            var breakingPoint = 18;
            return label.length <= breakingPoint
                ? this.makeSpacesNonBreaking(label)
                : this.makeSpacesNonBreaking(label.substr(0, breakingPoint)) +
                      label.substr(breakingPoint);
        },
        getTrClass: function (rowLevel, statisticIndex) {
            var vm = this;
            var classes = [];
            if (statisticIndex === 0) classes.push('first-row');
            else if (
                statisticIndex ===
                vm.reportModel.usedStatistics.length - 1
            )
                classes.push('last-row');
            if (rowLevel.rowLevel.id === 1) classes.push('first-group');
            else if (rowLevel.rowLevel.id === 0) classes.push('total-group');
            return classes.join(' ');
        }
    }
};
</script>

<style scoped>
td.row-heading,
td.hidden-heading-column {
    border-bottom: 1px solid #c1d5b0;
}

table td {
    overflow: hidden;
}

/*table tbody tr:last-child td {
      border: none;
    }*/

table td.statistic-total {
    text-align: center;
}
/*table td.nth-child(2) {
      white-space: nowrap;
    }*/
td {
    white-space: nowrap;
}

.statistic-label {
    padding: 0px 10px 0px 10px;
    /*white-space: nowrap;*/
}

table tr td:last-child {
    border-right: 2px solid;
}

table tr:not(.total-group) td.statistic-value {
    border-left: 2px solid;
}

td.statistic-value {
    padding-left: 10px;
}

table tr td.statistic-cell {
    border-top: 2px solid;
    border-bottom: 2px solid;
}
tr td {
    padding-top: 10px;
    padding-bottom: 10px;
}
/*table {
    padding-top: 15px;
  }

  table tr.first-row td {
    padding-top: 4px;
  }

  table tr.first-row td {
    padding-top: 15px;
  }

  table tr.last-row td {
    padding-bottom: 15px;
  }*/

div.column-title {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

.column-headings {
    background-color: #8eab6b;
    width: fit-content;
    padding: 5px 10px 5px 10px;
}

div.row-title {
    width: fit-content;
    background-color: #c1d5b0;
    padding: 5px 10px 5px 10px;
    min-width: 200px;
}

.row-heading {
    width: fit-content;
    background-color: #c1d5b0;
    white-space: inherit;
    padding: 5px 10px 5px 10px;
    font-weight: bold;
}

.hidden-heading-column {
    background-color: #c1d5b0;
}
</style>
